import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@sharedComponents/Typography';
import cx from 'classnames';

import * as style from './style.module.css';

const Tag = ({
    color = 'primary',
    textColor = null,
    size = null,
    fontSize = 's',
    onClick = null,
    icon = '',
    docked = false,
    className = '',
    children,
    iconPosition = 'right',
    noTruncate = false,
}) => {
    let resolvedTextColor = 'default';

    if (textColor) {
        resolvedTextColor = textColor;
    } else if (color === 'acid' || color === 'strong' || color === 'lavenderDark') {
        resolvedTextColor = 'white';
    } else if (color === 'lavender' || color === 'lavenderStrong') {
        resolvedTextColor = 'lavender';
    } else if (color === 'teal') {
        resolvedTextColor = 'teal';
    } else if (color === 'disabled') {
        resolvedTextColor = 'neutral-secondary';
    } else if (color === 'success') {
        resolvedTextColor = 'success-primary';
    } else if (color === 'warning') {
        resolvedTextColor = 'warning-primary';
    } else if (color === 'error') {
        resolvedTextColor = 'error-primary';
    }

    return (
        <div
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
            className={cx(style.tag, style[color], className, {
                [style[size]]: size,
                [style.isClickable]: onClick,
                [style.docked]: docked,
            })}
            style={resolvedTextColor !== 'default' ? { color: `var(--text-color-${resolvedTextColor})` } : undefined}
            onClick={onClick ?? undefined}
            onKeyDown={
                onClick
                    ? (e) => {
                          if (e.key === 'Enter' || e.key === ' ') onClick(e);
                      }
                    : undefined
            }
        >
            {icon && iconPosition === 'left' && <FontAwesomeIcon className={style.icon} icon={icon} />}
            <Typography
                className={noTruncate ? undefined : style.tagText}
                fontSize={fontSize}
                fontWeight="regular"
                color={resolvedTextColor === 'white' ? 'white' : resolvedTextColor}
            >
                {children}
            </Typography>
            {icon && iconPosition === 'right' && <FontAwesomeIcon className={style.icon} icon={icon} />}
        </div>
    );
};

export default Tag;
